export default __webpack_public_path__ + "static/media/trampapo_02_17.e4850a6f.jpg";